import React, { useEffect, useContext } from 'react';
import { getTmcv } from '../utils/getTmcv';
import { WidgetContext } from './WidgetContext';


function FlashbetWidget(props) {
    const widgetContext = useContext(WidgetContext);
    function randomString(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
           result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
     }
    
    // INSTANCE-ID
    function generateGUIFeedInstance(){
     return  randomString(8)  + '-' 
           + randomString(4) + '-'   
           + randomString(4) + '-' 
           + randomString(4) + '-' 
           + randomString(12);
    }
    
    // SESSION-ID
    function getFlashbetFeedSessionId(){
        //a partire dalla sessione del tomcat: ricavare un id così 12345678-1234-1234-1234-123456789123
        // E104F60EEF6DB553DDCDAF52E83C9ADF
        let rawSession = (getTmcv() || null);
        if(rawSession != null){
            if(rawSession.length < 32){
                let toAdd = '';
                for(var i = 0; i < (32 - rawSession.length); i++){
                    toAdd += '0';
                }
                rawSession = rawSession + toAdd;
            }
            rawSession = rawSession.substring(0, 8) + '-' 
                       + rawSession.substring(8, 12) + '-' 
                       + rawSession.substring(12, 16) + '-' 
                       + rawSession.substring(16, 20) + '-'
                       + rawSession.substring(20, 32);
            
            return rawSession;
        }
        else{
            return generateGUIFeedInstance();
        }
    }
    
    function preapareFlashbetWidgetUrl(url,matchId){
        return url && matchId && url
              .replace('{{ID_SESSION}}',getFlashbetFeedSessionId())
              .replace('{{INSTANCE}}',generateGUIFeedInstance())
              .replace('{{BETRADAR_ID}}',matchId)
    }

    var loadUrl = function (matchId) {
		var frames = document.querySelectorAll('.flashbetWidgetGeneral');
		if((frames || null) !== null){
            frames.forEach(function(frame){
                frame.src = preapareFlashbetWidgetUrl(props.url,matchId);

            })
		}
		
	};

	useEffect(() => {
        loadUrl(widgetContext.widgetMatchId);
    }, [widgetContext.widgetMatchId/* , widgetContext.widgetContainerId */]);

    return (
		<>
            <iframe title="flashbet-widget" scrolling="no" className="flashbetWidgetGeneral"></iframe>
		</>
    );
}






export default FlashbetWidget;